
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import eventBus from "@/utils/eventBus";
import { UserModule } from "@/store/modules/user";
import { ViewType } from "@/types/orderServicer";
import { checkPermissionCompany } from "@/utils/permission";
import { Type } from "@/types/permissionType";
import draggable from 'vuedraggable';
import SearchItem from '@/views/orderServicer/components/OrderSearchItem.vue';
import dayjs from 'dayjs';

@Component({
  name: "OrderServicerSearchCustom",
  components: {
    draggable,
    SearchItem
  },
})
export default class extends Vue {
  @Prop({
    default: ViewType.ORDER_SERVICER,
    validator: (value) => ViewType !== undefined,
  })
  private viewType?: ViewType;

  private orderForm: any = {
    addTimeRange: '',
    number: "",
    workNumber: "",
    orderStatus: "",
    orderType: "",
    orderResource: "",
    installSource: {},
    finishTimeRange: '',
    order_service_finish_state: "",
    order_service_polling_state: "",
    appointment_timestamp: "",
    transferIn: "",
    transferOut: "",
    troubleDescrible: "",
    repairMan: "",

    customerDept: {},

    person: "",
    contactWay: "",
    address: "",

    customer: {},
    hasBranch: false,
    companyLevel: 0,

    underwayOrderState: "",

    servicerDept: {},
    hasSubServicerDept: false,
    hasSubCustomerDept: false,

    evaluate_score: "",
    orderVerification: "",

    faultPhenomenon: {},
    faultType: {},
    tag: {},

    brand_product_model_name: {
      name: '',
      brandId: "",
      brandName: "",
      productId: "",
      productName: "",
      modelId: "",
      modelName: "",
    },
    order_warranty: "", // 原厂保修
    sn_number: "",
    isCharge: "",
    taskStatus: "",
    work_user_id: "",
    task_stage: "",
    taskAssignTime:'',
  };
  private brandProductModelReadonly = false;
  private labelBrand: any = "品牌类型";

  private searchArray: any = []
  private showSearchArray: any = []
  private isToggle = false
  private checkList: any = []
  private searchKey = ''
  private visiblePopover = false

  private yy = new Date().getFullYear();
  private mm = new Date().getMonth();
  private dd = new Date().getDate();

  created() {
    // alert("created")
    if (this.viewType === ViewType.ORDER_SERVICER_ALL ||
      this.viewType === ViewType.ORDER_SERVICER_COMPLETED || this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE) {
      const threeMonthsAgoTime = dayjs().subtract(3, 'month').hour(0).minute(0).second(0).valueOf();
      this.$set(
        this.orderForm,
        'addTimeRange',
        [threeMonthsAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
      )
    }
    if (this.$route.query.work_user_id) {
      this.orderForm.work_user_id = this.$route.query.work_user_id;
    } else {
      this.orderForm.work_user_id = "";
    }
    if (this.$route.query.task_stage) {
      this.orderForm.task_stage = this.$route.query.task_stage;
    } else {
      this.orderForm.task_stage = "";
    }
    if (UserModule.company.brand_name_alias) {
      this.labelBrand = UserModule.company.brand_name_alias;
    } else {
      this.labelBrand = "品牌类型";
    }

    this.setSearch();

   
    setTimeout(() => {
      this.handleSearch()
    })
  }

  private  setSearch(){
    this.searchKey = "lsjl_search" + this.$route.path;
    let index = this.searchKey.lastIndexOf("/");
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        localParse[p].fields = '';
        localParse[p].isClearable = true;
      }
      if (this.viewType === ViewType.ORDER_SERVICER_ALL ||
      this.viewType === ViewType.ORDER_SERVICER_COMPLETED || this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE ) {
        for (let p = 0; p < localParse.length; p++) {
          if (localParse[p].id === '1') {
            const threeMonthsAgoTime = dayjs().subtract(3, 'month').hour(0).minute(0).second(0).valueOf();
            localParse[p].fields = [threeMonthsAgoTime , new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()];
            localParse[p].isClearable = false;
          }
        }
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        { fields: this.orderForm.addTimeRange, name: '报修日期', id: '1', checked: true, show: true, isClearable: this.viewType !== 1 && this.viewType !== 2, isDisabled: true },
        { fields: this.orderForm.number, name: '订单号', id: '2', checked: true, show: true, isClearable: true },
        { fields: this.orderForm.workNumber, name: '工单号', id: '3', checked: true, show: false, isClearable: true },
        { fields: this.orderForm.orderStatus, name: '订单状态', id: '4', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.orderType, name: '订单类型', id: '5', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.orderResource, name: '订单来源', id: '6', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.installSource, name: '安装来源', id: '7', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.finishTimeRange, name: '完结日期', id: '8', checked: true, show: true, isClearable: true },
        { fields: this.orderForm.order_service_finish_state, name: '完结状态', id: '9', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.order_service_polling_state, name: '巡检状态', id: '10', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.appointment_timestamp, name: '预约时间', id: '11', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.transferIn, name: '转入方', id: '12', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.transferOut, name: '转出方', id: '13', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.troubleDescrible, name: '任务描述', id: '36', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.repairMan, name: '申请人', id: '14', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.customerDept, name: '报修部门', id: '15', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.person, name: '联系人', id: '16', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.contactWay, name: '联系方式', id: '17', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.address, name: '联系地址', id: '18', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.customer, name: '客户', id: '19', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.work_user_id, name: '工程师', id: '20', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.underwayOrderState, name: '进行状态', id: '21', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.servicerDept, name: '服务部门', id: '22', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.evaluate_score, name: '评价', id: '23', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.orderVerification, name: '核销状态', id: '24', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.faultPhenomenon, name: '故障现象', id: '25', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.faultType, name: '故障类型', id: '26', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.tag, name: '标签', id: '32', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.brand_product_model_name, name: this.labelBrand, id: '27', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.order_warranty, name: '是否为原厂保修', id: '28', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.sn_number, name: 'SN号', id: '29', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.isCharge, name: '费用', id: '30', checked: false, show: true, isClearable: true },
        { fields: this.orderForm.taskStatus, name: '任务', id: '31', checked: false, show: false, isClearable: true },
        { fields: this.orderForm.taskAssignTime, name: '指派日期', id: '33', checked: false, show: false, isClearable: true },
      ]
    }

    for (let i = 0; i < this.searchArray.length; i++) {
      if (this.searchArray[i].id === '7') {
        this.searchArray[i].show = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.InstallModule
        );
      }
      // 客户模块
      if (this.searchArray[i].id === '19') {
        this.searchArray[i].show = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.CUSTOMER_COMPANY
        )
      }
      // 判断有库存模块才有核销状态
      if (this.searchArray[i].id === '24') {
        this.searchArray[i].show = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.Stock
        )
      }
      if (this.searchArray[i].id === '26') { // 故障类型
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.fault);
      }
      if (this.searchArray[i].id === '25') { // 故障现象
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.FAULT_PHENOMENON);
      }
      if (this.searchArray[i].id === '32') { // 标签
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.tag);
      }
    }

    // 赵子龙说  完结时间 只有 所有1 完结2  回收站5 有
    if (this.viewType === 1) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '4') { // 订单状态4
          this.searchArray[i].show = true
        }
      }
    } else {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '4') { // 订单状态4
          this.searchArray[i].show = false
        }
      }
    }
    if (this.viewType === 2) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '9' || this.searchArray[i].id === '10') { // 完结状态9 巡检状态10
          this.searchArray[i].show = true
        }
        // 工单号3
        if (this.searchArray[i].id === '3') {
          this.searchArray[i].show = checkPermissionCompany(
            UserModule.getCompanyId,
            Type.workOrderNum
          );
        }
      }
    } else {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '9' || this.searchArray[i].id === '10') { // 完结状态9 巡检状态10
          this.searchArray[i].show = false
        }
      }
    }
    if (this.viewType === 1 || this.viewType === 2) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '23' || this.searchArray[i].id === '28') { // 评价23 原厂保修28
          this.searchArray[i].show = true
        }
      }
    } else {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '23' || this.searchArray[i].id === '28') { // 评价23 原厂保修28
          this.searchArray[i].show = false
        }
      }
    }
    if (this.viewType === 5 || this.viewType === 1 || this.viewType === 2) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '8') { // 完结日期8
          this.searchArray[i].show = true
        }
      }
    } else {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '8') { // 完结日期
          this.searchArray[i].show = false
        }
      }
    }
    if (this.viewType === 3) { // 抢单列表
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '4' || this.searchArray[i].id === '20') { // 订单状态 工程师
          this.searchArray[i].show = false
        }
      }
    }
    if (this.viewType === 8) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '21' || this.searchArray[i].id === '31') { // 进行状态 任务
          this.searchArray[i].show = true
        }
      }
    } else {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '21' || this.searchArray[i].id === '31') { // 进行状态 任务
          this.searchArray[i].show = false
        }
      }
    }

    if (this.viewType === 8 || this.viewType === 1 || this.viewType === 2) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '33') { // 完结日期8
          this.searchArray[i].show = true
        }
      }
    }

    if (this.viewType === 23) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '30') { // 结算不显示费用搜索项
          this.searchArray[i].show = false
        }
      }
    }

    for (let i = 0; i < this.searchArray.length; i++) {
      if (this.searchArray[i].id === '27') {
        this.searchArray[i].name = this.labelBrand;
      }
    }
    // console.log(this.searchArray);
    this.showSearchArray = this.searchArray.filter((v: any) => {
      return v.show === true;
    });

  }

  mounted() {
    // alert("mounted");
 

  }

  getManyDays() {
    let yyyy = 365;
    let y = new Date(this.orderForm.endTime).getFullYear();
    let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
    if (flag) {
      yyyy = 366;
    }
    return yyyy;
  }

  handleCleanSearch() {
    this.orderForm = {
      addTimeRange: '',
      number: "",
      orderStatus: "",
      orderType: "",
      orderResource: "",
      underwayOrderState: "",
      installSource: {},
      finishTimeRange: '',
      appointment_timestamp: "",
      transferIn: "",
      transferOut: "",
      troubleDescrible:"",
      repairMan: "",
      customerDept: {},
      person: "",
      contactWay: "",
      address: "",
      customer: {},
      hasBranch: false,
      servicerDept: {},
      hasSubServicerDept: false,
      hasSubCustomerDept: false,
      evaluate_score: "",
      orderVerification: "",
      faultPhenomenon: {},
      faultType: {},
      tag: {},
      brand_product_model_name: {
        name: '',
        brandId: "",
        brandName: "",
        productId: "",
        productName: "",
        modelId: "",
        modelName: "",
      },
      order_warranty: "",
      order_service_finish_state: "",
      order_service_polling_state: "",
      isCharge: "",
      sn_number: "",
      workNumber: "",
      work_user_id: "",
      task_stage: "",
      taskAssignTime: '',
    };

    let query = JSON.parse(JSON.stringify(this.$route.query));
    query.work_user_id = "";
    query.task_stage = "";
    query.is_send_eng = "";
    this.$router.push({
      path: this.$route.path,
      query: query,
    }); // 路由会报错，后期可能会改吧

    // 重置所有选项
    if (this.searchArray) {
      for (let p = 0; p < this.searchArray.length; p++) {
        if (!((this.viewType === ViewType.ORDER_SERVICER_ALL || this.viewType === ViewType.ORDER_SERVICER_COMPLETED || this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE) && this.searchArray[p].id === '1')) {
          this.searchArray[p].fields = ''
        } else {
          const threeMonthsAgoTime = dayjs().subtract(3, 'month').hour(0).minute(0).second(0).valueOf();
          this.searchArray[p].fields =  [ threeMonthsAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime() ]
        }
      }
    }
    if (this.viewType === ViewType.ORDER_SERVICER_ALL || this.viewType === ViewType.ORDER_SERVICER_COMPLETED ||  this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE) {
      const threeMonthsAgoTime = dayjs().subtract(3, 'month').hour(0).minute(0).second(0).valueOf();
      this.$set(
        this.orderForm,
        'addTimeRange',
        [ threeMonthsAgoTime, new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime() ]
      )
    } else {
      this.$set(this.orderForm, 'addTimeRange', '')
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      start_time: this.orderForm.addTimeRange ? this.orderForm.addTimeRange[0] / 1000 : '', // 新增的 参数
      end_time: this.orderForm.addTimeRange ? this.orderForm.addTimeRange[1] / 1000 +86400: '',
    };
    eventBus.$emit("orderServicerOrderSearch", params);
  }

  handleSearch() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      order_num: this.orderForm.number,
      order_state: this.orderForm.orderStatus,
      order_source: this.orderForm.orderResource,
      order_type: this.orderForm.orderType.value,
      start_time: this.orderForm.addTimeRange ? this.orderForm.addTimeRange[0] / 1000 : '',
      end_time: this.orderForm.addTimeRange ? this.orderForm.addTimeRange[1] / 1000 + 86400: '',
      finish_start_time: this.orderForm.finishTimeRange ? this.orderForm.finishTimeRange[0] / 1000 : "",
      finish_end_time: this.orderForm.finishTimeRange ? this.orderForm.finishTimeRange[1] / 1000 + 86400 : "",
      transfer_in_company_name: this.orderForm.transferIn,
      transfer_out_company_name: this.orderForm.transferOut,
      trouble_describle: this.orderForm.troubleDescrible,
      create_user_name: this.orderForm.repairMan,
      customer_company_id: this.orderForm.customer.id ? this.orderForm.customer.id : "",
      company_level: this.orderForm.companyLevel,
      customer_dept_id: this.orderForm.customerDept.id ? this.orderForm.customerDept.id : '',
      contain_branch: this.orderForm.hasBranch ? 1 : 0,
      name: this.orderForm.person,
      mobile: this.orderForm.contactWay,
      address: this.orderForm.address,
      servicer_dept_id: this.orderForm.servicerDept.id ? this.orderForm.servicerDept.id : '',
      contain_sub_servicer_dept_id: this.orderForm.hasSubServicerDept ? 1 : 0,
      contain_sub_customer_dept_id: this.orderForm.hasSubCustomerDept ? 1 : 0,
      fault_phenomenon_id: this.orderForm.faultPhenomenon.id ? this.orderForm.faultPhenomenon.id : '',
      fault_phenomenon_name: this.orderForm.faultPhenomenon.name ? this.orderForm.faultPhenomenon.name : '',
      fault_id: this.orderForm.faultType.id ? this.orderForm.faultType.id : '',
      tags_ids: this.orderForm.tag && this.orderForm.tag.id ? this.orderForm.tag.id : '',
      order_service_finish_state:
        parseInt(this.orderForm.order_service_finish_state) !== 0
          ? this.orderForm.order_service_finish_state
          : "",
      // 巡检状态的搜索项
      polling_check_state: this.orderForm.order_service_polling_state,
      price_state: this.orderForm.isCharge,
      evaluate_score: this.orderForm.evaluate_score,
      // 核销选择项
      is_charge_off: this.orderForm.orderVerification,

      // 搜索品牌类型
      brand_id: this.orderForm.brand_product_model_name.brandId ? this.orderForm.brand_product_model_name.brandId : '',
      brand_name: this.orderForm.brand_product_model_name.brandName ? this.orderForm.brand_product_model_name.brandName : '',
      product_id: this.orderForm.brand_product_model_name.productId ? this.orderForm.brand_product_model_name.productId : '',
      product_name: this.orderForm.brand_product_model_name.productName ? this.orderForm.brand_product_model_name.productName : '',
      model_id: this.orderForm.brand_product_model_name.modelId ? this.orderForm.brand_product_model_name.modelId : '',
      model_name: this.orderForm.brand_product_model_name.modelName ? this.orderForm.brand_product_model_name.modelName : '',
      brand_product_model_name: this.orderForm.brand_product_model_name.name ? this.orderForm.brand_product_model_name.name : '',
      order_warranty: this.orderForm.order_warranty ? "1" : "0",
      sn_number: this.orderForm.sn_number,
      work_order_num: this.orderForm.workNumber,
      stage_sub_search: this.orderForm.underwayOrderState,
      task_finish_state: this.orderForm.taskStatus,
      install_source_id: this.orderForm.installSource.id ? this.orderForm.installSource.id : "",

      work_user_id: this.orderForm.work_user_id,
      task_stage: this.orderForm.task_stage,
      assign_start_time: this.orderForm.taskAssignTime ? this.orderForm.taskAssignTime[0] / 1000 : '',
      assign_end_time: this.orderForm.taskAssignTime ? this.orderForm.taskAssignTime[1] / 1000 + 86400: '',
    };
    if(params.order_state== 165) {
      params.order_state = 16;
      params.task_finish_state = 5;
    }
    eventBus.$emit("orderServicerOrderSearch", params);
  }

  private orderFormReceive(val: any, keyup: any) {
    switch (val.id) {
      case '1':
        this.orderForm.addTimeRange = val.fields;
        break;
      case '2':
        this.orderForm.number = val.fields;
        break;
      case '3':
        this.orderForm.workNumber = val.fields;
        break;
      case '4':
        this.orderForm.orderStatus = val.fields;
        break;
      case '5':
        this.orderForm.orderType = val.fields;
        break;
      case '6':
        this.orderForm.orderResource = val.fields;
        break;
      case '7':
        this.orderForm.installSource = val.fields;
        this.orderForm.orderType = this.orderForm.installSource.orderType;
        for (let i = 0; i < this.searchArray.length; i++) {
          if (this.searchArray[i].id === '5') { // 订单类型
            this.searchArray[i].fields = this.orderForm.orderType
          }
        }
        break;
      case '8':
        this.orderForm.finishTimeRange = val.fields;
        break;
      case '9':
        this.orderForm.order_service_finish_state = val.fields;
        break;
      case '10':
        this.orderForm.order_service_polling_state = val.fields;
        break;
      case '11':
        this.orderForm.appointment_timestamp = val.fields;
        break;
      case '12':
        this.orderForm.transferIn = val.fields;
        break;
      case '13':
        this.orderForm.transferOut = val.fields;
        break;
      case '36':
        this.orderForm.troubleDescrible = val.fields;
        break;
      case '14':
        this.orderForm.repairMan = val.fields;
        break;
      case '15':
        this.orderForm.customerDept = val.fields;
        this.orderForm.hasSubCustomerDept = this.orderForm.customerDept.hasSubCustomerDept;
        break;
      case '16':
        this.orderForm.person = val.fields;
        break;
      case '17':
        this.orderForm.contactWay = val.fields;
        break;
      case '18':
        this.orderForm.address = val.fields;
        break;
      case '19':
        this.orderForm.customer = val.fields;
        this.orderForm.companyLevel = this.orderForm.customer.companyLevel;
        this.orderForm.hasBranch = this.orderForm.customer.hasBranch;
        break;
      case '20':
        this.orderForm.work_user_id = val.fields.id;
        break;
      case '21':
        this.orderForm.underwayOrderState = val.fields;
        break;
      case '22':
        this.orderForm.servicerDept = val.fields;
        this.orderForm.hasSubServicerDept = this.orderForm.servicerDept.hasSubServicerDept;
        break;
      case '23':
        this.orderForm.evaluate_score = val.fields;
        break;
      case '24':
        this.orderForm.orderVerification = val.fields;
        break;
      case '25':
        this.orderForm.faultPhenomenon = val.fields;
        break;
      case '26':
        this.orderForm.faultType = val.fields;
        break
      case '32':
        this.orderForm.tag = val.fields;
        break;
      case '27':
        this.orderForm.brand_product_model_name = val.fields;
        break;
      case '28':
        this.orderForm.order_warranty = val.fields;
        break;
      case '29':
        this.orderForm.sn_number = val.fields;
        break;
      case '30':
        this.orderForm.isCharge = val.fields;
        break;
      case '31':
        this.orderForm.taskStatus = val.fields;
        break;
      case '33':
        this.orderForm.taskAssignTime = val.fields;
      break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }

  resetHandle() {
    if (localStorage.getItem(this.searchKey)) {
       localStorage.removeItem(this.searchKey);
    }
    this.setSearch();
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter((t: any) =>
      (!this.checkList.some((ele: any) => ele.id === t.id)) && t.show
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
